import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import {Swiper, Navigation, Pagination, Autoplay, Keyboard, Thumbs} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SwiperAnimation from '@cycjimmy/swiper-animation';
window.Swiper = Swiper;

// Alpine
// import Alpine from 'alpinejs'
// import Focus from '@alpinejs/focus'
// import mask from '@alpinejs/mask'
// import Collapse from '@alpinejs/collapse'
// import FormsAlpinePlugin from '../../../../../../../../vendor/filament/forms/dist/module.esm'
// import DateTimePickerFieldFormComponent from '../../../../../../../../vendor/ariaieboy/filament-jalali-datetimepicker/resources/js/components/jalali-date-time-picker'
//
// Alpine.plugin(Focus);
// Alpine.plugin(mask)
// Alpine.plugin(Collapse);
// Alpine.plugin(DateTimePickerFieldFormComponent);
// Alpine.plugin(FormsAlpinePlugin);
// window.Alpine = Alpine

// Test
// import Quagga from 'quagga';
// window.Quagga = Quagga;

import Accordion from './utils/accordion';
import ExploreModal from './utils/modal';
import ExploreSidebar from './utils/fullscreen-sidebar'
// import NavbarScroll from './utils/nav-scroll'
import AOS from 'aos';

// Turbo links
// import * as Turbo from "@hotwired/turbo"


// Lazyload
// import lazyLoadInit from '../../../../general/js/lazy';
// lazyLoadInit();

// Lazyload
import lazySizes from 'lazysizes';

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// LightBox
import SimpleLightbox from "simplelightbox";
import 'simplelightbox/dist/simple-lightbox.min.css';

const lightbox = new SimpleLightbox('.gallery-lightbox a', {
    rtl: true,
    overlayOpacity: .8,
});
window.lightbox = lightbox;


// fslightbox
import FsLightbox from "fslightbox";


const buildSwiperCustom = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;

    let delay = typeof sliderElm.dataset.delay !== 'undefined' ? sliderElm.dataset.delay : 2500 ;
    let slides_xs = typeof sliderElm.dataset.xs !== 'undefined' ? sliderElm.dataset.xs : 3 ;
    let slides_md = typeof sliderElm.dataset.md !== 'undefined' ? sliderElm.dataset.md : 4 ;
    let slides_lg = typeof sliderElm.dataset.lg !== 'undefined' ? sliderElm.dataset.lg : 5 ;
    let slides_xl = typeof sliderElm.dataset.xl !== 'undefined' ? sliderElm.dataset.xl : 6 ;

    let center_slides = typeof sliderElm.dataset.center_slides !== 'undefined' ? sliderElm.dataset.center_slides : false ;
    let center_slides_bounds = typeof sliderElm.dataset.center_slides_bounds !== 'undefined' ? sliderElm.dataset.center_slides_bounds : false ;
    let loop = typeof sliderElm.dataset.loop !== 'undefined' ? sliderElm.dataset.loop : false ;
    let navigation = typeof sliderElm.dataset.navigation !== 'undefined' ? sliderElm.dataset.navigation : false ;

    return new Swiper('[data-id="'+sliderIdentifier+'"]', {
        modules: [Navigation, Autoplay],
        direction:'horizontal',
        slidesPerView:slides_xs,
        spaceBetween:15,
        centeredSlides:center_slides,
        centeredSlidesBounds:center_slides_bounds,
        loop: loop,
        autoplay: {
            delay: delay,
            disableOnInteraction: false,
        },
        navigation: {
            enabled: navigation,
            nextEl: '.swiper-button-next-slide-' + sliderIdentifier,
            prevEl: '.swiper-button-prev-slide-' + sliderIdentifier,
            disabledClass:'!bg-gray-700 text-gray-200'
        },
        breakpoints: {
            // // xs
            // 520: {
            //     slidesPerView:1.6,
            //     spaceBetween:15,
            // },
            // // sm
            // 640:{
            //     slidesPerView:2,
            //     spaceBetween:15,
            // },
            // md
            768: {
                slidesPerView:slides_md,
                spaceBetween:15,
            },
            // lg
            1024:{
                slidesPerView:slides_lg,
                spaceBetween:15,
            },
            // xl
            1280:{
                slidesPerView:slides_xl,
                spaceBetween:15,
            },
            // 2xl
            // 1536: {

            // },
        }
    });
}

const setupApp = ()=>
{
    lazySizes.init();

    refreshFsLightbox();
    lightbox.refresh();

    AOS.init();

    let swiperAnimation = new SwiperAnimation();

    const heroSwiper = new Swiper('.hero-swiper-container', {
        direction: 'horizontal',
        loop: true,
        autoplay: {
            delay: 5000,
            waitForTransition: false,
        },
        keyboard: true,
        speed: 1000,
        modules: [Navigation, Pagination, Autoplay, Keyboard],
        pagination: {
            el: '.swiper-pagination',
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function () {
                swiperAnimation.init(this).animate();
            },
            slideChange: function () {
                swiperAnimation.init(this).animate();
            }
        }
    });

    // AOS.init();

    document.querySelectorAll('.home-slider .swiper-slide').forEach(slide => {
        slide.style.height = window.innerHeight + 'px'
    })

    let mainSwiper = new Swiper('.main-swiper', {
        modules: [Navigation, Pagination, Autoplay, Keyboard],
        direction: 'horizontal',
        slidesPerView: 1,
        freeMode:true,
        clickable: "true",
        loop: true,
        autoplay: {
            delay: 5000,
            waitForTransition: false,
        },
        keyboard: true,
        speed: 1000,
        navigation: {
            nextEl: '.main-swiper-button-next',
            prevEl: '.main-swiper-button-prev',
            disabledClass: 'text-gray-400',
        },
    });

    let productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    let productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let allSwipersCustom = document.querySelectorAll('.custom-swiper');
    allSwipersCustom.forEach(slider => buildSwiperCustom(slider));

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });

    let specialProductsSwiper = new Swiper("#specialProductsSwiper", {
        modules: [Navigation],
        slidesPerView: 1.4,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3.2,
            },
            1280: {
                slidesPerView: 4.3,
            },
        },
        // navigation: {
        //     nextEl: "#specialCategoriesSwiperNext",
        //     prevEl: "#specialCategoriesSwiperPrev",
        // },
    });
};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
});

// console.clear();
